module.exports = __webpack_public_path__ + "static/media/faq-join-affiliate.cbb2c200.jpg";